import React from 'react';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainSearchGateModule } from './domainSearchGate.module';
export const ModalsProvider = _ref => {
  let children = _ref.children;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.InsightsModals, null), children);
};
//# sourceMappingURL=ModalsProvider.js.map